module.exports = __webpack_public_path__ + "static/logo_sm-5481f214dc90316fc3d39dca7d16215d.png";